// === Zod schemas: rate_hectares ===
// Ported from PHP Click2Gro: RateHectreModel / RateHectre entity (admin/global table)
// Table: rate_hectares (corrects original typo "rate_hectre")
// Simple lookup: integer water-rate-per-hectare values (e.g. 100, 250, 500).

import { z } from 'zod';

export const RateHectareSchema = z.object({
  id:               z.number().int().positive(),
  rate_per_hectare: z.number().int().nullable(),
  created_by:       z.string().max(300).nullable(),
  updated_by:       z.string().max(300).nullable(),
  created_at:       z.string().datetime({ offset: true }).nullable(),
  updated_at:       z.string().datetime({ offset: true }).nullable(),
  deleted_at:       z.string().datetime({ offset: true }).nullable(),
});

export const RateHectareInsertSchema = RateHectareSchema.omit({
  id:         true,
  created_at: true,
  updated_at: true,
  deleted_at: true,
}).partial({
  created_by: true,
  updated_by: true,
});

export const RateHectareUpdateSchema = RateHectareInsertSchema.partial();

export type RateHectare       = z.infer<typeof RateHectareSchema>;
export type RateHectareInsert = z.infer<typeof RateHectareInsertSchema>;
export type RateHectareUpdate = z.infer<typeof RateHectareUpdateSchema>;
